import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import ModalMakeCardPrimarySuccessfully from 'screens/ModalMakeCardPrimarySuccessfully';
import ModalMakeCardPrimaryFailed from 'screens/ModalMakeCardPrimaryFailed';
import { SET_CREDIT_CARD_PRIMARY } from 'graphql/service';
import { useMutation } from '@apollo/client';
import colors from 'constants/colors';
import { Container } from './styles';

const ModalMakeCardPrimary = ({
  isOpen,
  setIsOpen,
  paymentCardId,
  amount,
  originCardNumber,
  newCardNumber,
  setPaymentRecords
}) => {

  const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false)
  const [failedIsOpen, setFailedIsOpen] = useState(false)

  const [setCreditCardPrimary, { loading }] = useMutation(SET_CREDIT_CARD_PRIMARY, {
    onCompleted: (data) => {
      setPaymentRecords((prevRecords) => 
        prevRecords.map(record => ({
          ...record,
          isPrimary: record.paymentCardId === paymentCardId
        }))
      )
      setIsOpen(false)
      setSuccessfullyIsOpen(true)
    },
    onError: (error) => {
      setIsOpen(false)
      setFailedIsOpen(true)
    }
  })

  const handleSubmit = () => {
    if(loading) return
    setCreditCardPrimary({
      variables: {
        input: {
          paymentCardId: paymentCardId
        }
      }
    })
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            height: 100%;
            .close {
              z-index: 200;
            }   
            .modal-body{
              position: relative;
              height: 100%;
            }
          }
          background: ${colors.black5};
          top: 179px;
        `}
      >
        <Container>
          <div className='text'>Are you sure you want to make this the primary card?</div>
          <Button
            success
            onClick={handleSubmit}
            data-loading={loading}
            additionalstyle={`
              width: 166px;
              margin-top: 24px;
            `} 
          >
            {loading? null: 'Yes, make primary'}
          </Button>
        </Container>
      </MainModal>
      <ModalMakeCardPrimarySuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
      />
      <ModalMakeCardPrimaryFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        amount={amount}
        originCardNumber={originCardNumber}
        newCardNumber={newCardNumber}
      />
    </>
  );
}

export default ModalMakeCardPrimary;
